import { useEffect, useState } from "react";
import CancerCareTool from "./cancer-care/CancerCareTool";
// @ts-ignore: missing type declarations for apimethod.js
import { API } from "../Services/apimethod.js";
// @ts-ignore: missing type declarations for apimethod.js
import { encryptData, decodedPlaload, getTokenExp,decodedPlaloadOne } from "../Services/req_res_decode_encode.js";

const user_key = import.meta.env.VITE_AUTH_KEY;

export default function Home() {
  const [loading, setLoading] = useState(true);
  const [isSccess, setIsSccess] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [t_Exp, setT_exp] = useState("");

  const getAuth = async () => {
    debugger
    let auth = localStorage.getItem(user_key);
    if (auth != null) {
      const data = decodedPlaloadOne(auth);
      const payload = {
        login_id: data?.user?.login_id,
      };

      const resp = await API.CreateMethod("validate_login_id", {
        payload: encryptData(payload),
      });

      if (resp && resp?.status == 200) {
        setIsSccess(true);
        setOpenAlert(false);
        const url = new URL(window.location.href);
        url.searchParams.delete("token");
        window.history.replaceState({}, "", url);
      } else {
        setIsSccess(false);
        setOpenAlert(true);
      }

      setLoading(false);
      return;
    }

    let url = window.location.href;
    let t = url?.split("token=")[1];
    if (t) {
      localStorage.setItem(user_key, t);
      const data = decodedPlaloadOne(t);
      const payload = { login_id: data?.user?.login_id };
      const resp = await API.CreateMethod("validate_login_id", {
        payload: encryptData(payload),
      });

      if (resp && resp?.status == 200) {
        setIsSccess(true);
        setOpenAlert(false);
        const urlObj = new URL(window.location.href);
        urlObj.searchParams.delete("token");
        window.history.replaceState({}, "", urlObj);
      } else {
        setIsSccess(false);
        setOpenAlert(true);
      }
    } else {
      setIsSccess(false);
      setOpenAlert(true);
    }
    setLoading(false);
  };

  const clearClientData = async () => {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
    });
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }
  };

  useEffect(() => {
    let url = window.location.href;
    let t = url?.split("token=")[1];
    if (t) {
      clearClientData();
      getAuth();
      setT_exp("");
    } else {
      if (getTokenExp()) {
        setT_exp("Your Login is expired!");
        setOpenAlert(true);
        setIsSccess(false);
        setLoading(false);
      } else {
        setIsSccess(true);
        setOpenAlert(false);
        setLoading(false);
      }
    }
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Authenticating...</div>;
  }

  if (!openAlert) {
    return <CancerCareTool />;
  }
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div
        className="bg-white rounded-xl p-6 shadow-xl w-[90%] max-w-md text-center"
        style={{ padding: 20 }}
      >
        <h2 className="text-red-600 text-xl font-bold mb-4"></h2>

        <p className="mb-6" style={{ marginTop: 10 }}>
          {t_Exp ? t_Exp : "You don't have access to this module yet"}
        </p>

        <button
          onClick={() => {
            localStorage.clear();
            setTimeout(() => {
              window.location.href = import.meta.env.VITE_LOGINURL;
            }, 1000);
          }}
          className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg"
          style={{ width: 50, marginTop: 20 }}
        >
          Ok
        </button>
      </div>
    </div>
  );
}
